import React from "react";
import ValueCounter from "../ValueCounter";
import * as Styled from "./styles.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AutoScrollAccordion from "../AutoScrollAccordion";

function PaddingBox({
  padding = {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
  increasePadding,
  decreasePadding,
  AccordionContainerStyle,
  fullWidth,
  handlePaddingChange = () => {},
}) {
  const paddingOptions = [
    "Top",
    "Bottom",
    "Left",
    "Right",
  ];

  return (
    <div>
      <AutoScrollAccordion
        title={"Padding"}
        AccordionSummaryStyle={{
          p: 0,
          m: 0,
        }}
        AccordionContainerStyle={AccordionContainerStyle}
        RightIconComponent={ExpandMoreIcon}
        isTootTipShow={true}
        toolTipDescription={`The space inside the element's border, creating internal space between the element's content and its border.`}
      >
        <Styled.Container>
          <Styled.RowDiv>
            {paddingOptions.map((side, index) => (
              <ValueCounter
                key={index}
                title={side}
                value={padding[side.toLowerCase()]}
                onClickIncrease={() => increasePadding(side.toLowerCase())}
                onClickDecrease={() => decreasePadding(side.toLowerCase())}
                disabled={fullWidth && (side == "Left" || side == "Right")}
                handleChange={handlePaddingChange}
              />
            ))}
          </Styled.RowDiv>
        </Styled.Container>
      </AutoScrollAccordion>
    </div>
  );
}

export default PaddingBox;
